import NotifyConnector from './notify.props';
import NotifyComponent from './notify.component';

export default NotifyConnector(NotifyComponent);
